export const FULL_URL_REQUIRED_MESSAGE =
  "Enter a full URL starting with http:// or https://";

export const INVALID_URL_MESSAGE = "Enter a valid URL";

/**
 * Why a link the editor checks as written isn't an http(s) URL, or undefined
 * when it is. A link must name the scheme, since the URL parser accepts any.
 */
export function linkUrlError(url: string): string | undefined {
  if (!/^https?:\/\//i.test(url)) return FULL_URL_REQUIRED_MESSAGE;
  return URL.canParse(url) ? undefined : INVALID_URL_MESSAGE;
}
